import { Injectable } from '@angular/core';
import { OnlineApplicationRequestPayload } from '../models/RequestPayloads/OnlineApplicationRequestPayload';
import { HttpinterceptorService } from './httpinterceptor';
import { UrlProviderService } from './local/url-provider.service';
import { CheckUserOnlineApplicationResponse } from '../models/Response/CheckUserOnlineApplicationResponse';
import { PurchaseNewProductsRequestPayload } from '../models/RequestPayloads/PurchaseNewProductsRequestPayload';
import { GenericResponse } from '../models/Response/GenericResponse';
import { GetOnlineApplicationByToken } from '../models/RequestPayloads/GetOnlineApplicationByToken';
import { SendAppLinkToAgentRequest } from '../models/RequestPayloads/SendAppLinkToAgentRequest';
import { UpdateGibRegistrationDateRequest } from '../models/RequestPayloads/UpdateGibRegistrationDateRequest';
import { OnlineAppHistoryModel } from '../models/Response/OnlineAppHistoryModel';
import { CancelProduct } from '../models/RequestPayloads/CancelProduct';
import { Router } from '@angular/router';
import { CancelOnlineApplicationModel } from '../models/RequestPayloads/CancelOnlineApplicationModel';
import { PaymentOptionListComponentModel } from '../models/ComponentModels/PaymentOptionListComponentModel';
import { PaymentInitialRequest } from '../models/RequestPayloads/PaymentInitialRequest';
import { PaymentInitialResponseModel } from '../models/Response/PaymentInitialResponseModel';
import { PaymentChargeRequestModel } from '../models/RequestPayloads/PaymentChargeRequestModel';
import { PaymentChargeResponseModel } from '../models/Response/PaymentChargeResponseModel';
import { CustomerInventoryRequestPayload } from '../models/RequestPayloads/CustomerInventoryRequestPayload';
import { PartnerModelRequestPayload } from '../models/RequestPayloads/PartnerModelRequestPayload';
import { CustomerMembership } from '../models/RequestPayloads/CustomerMembership';
import { NoDataDto } from '../models/Response/NoDataDto';
import { CustomerPackagesRequestModel } from '../models/RequestPayloads/CustomerPackagesRequestModel';
import { MainMenuResponseModel } from '../models/Response/MainMenuResponseModel';
import { PaymentInformationRequestModel } from '../models/RequestPayloads/PaymentInformationRequestModel';
import { PaymentCancelRequestModel } from '../models/RequestPayloads/PaymentCancelRequestModel';
import { PaymentCancelResponseModel } from '../models/Response/PaymentCancelResponseModel';
import { OnlineApplicationRequestModel } from '../models/RequestPayloads/OnlineApplicationRequestModel';
import { AesService } from './local/aes.service';

@Injectable({
  providedIn: 'root'
})
export class OnlineApplicationService {

  constructor(private http: HttpinterceptorService, private urlProvider: UrlProviderService, private router: Router,private aesService : AesService) { }

  public submitApplication(requestPayload: OnlineApplicationRequestPayload, isAgentEdit: any): Promise<any> {
    return this.http.postRequest(this.urlProvider.getSubmitApplicationURL(isAgentEdit), requestPayload).toPromise().then((res: GenericResponse<string>) => res)
  }

  public getApplication(uuid: string, identifier: string, isMainPrewiew : boolean = false): Promise<OnlineApplicationRequestPayload> {
    return this.http.getRequest(this.urlProvider.getGetApplicationURL(uuid, identifier,isMainPrewiew)).toPromise().then((res: OnlineApplicationRequestPayload) => res);
  }

  public checkByIdentifier(identifier: string): Promise<CheckUserOnlineApplicationResponse> {
    var url = this.urlProvider.checkOnlineApplicationByIdentifier(identifier);
    return this.http.getRequest(url).toPromise().then((res: CheckUserOnlineApplicationResponse) => res)
  }

  public checkMailConfirmationCode(identifier: string, confirmCode: string): Promise<CheckUserOnlineApplicationResponse> {
    var url = this.urlProvider.checkOnlineApplicationConfirmationCode(identifier, confirmCode);
    return this.http.getRequest(url, true).toPromise().then((res: CheckUserOnlineApplicationResponse) => res)
  }
  public sendDraft(requestPayload: OnlineApplicationRequestPayload): Promise<any> {
    return this.http.postRequest(this.urlProvider.getSaveDraftURL(), requestPayload).toPromise().then((res: any) => res)
  }
  public purchaseNewProducts(requestPayload: PurchaseNewProductsRequestPayload, uuid): Promise<GenericResponse<string>> {
    return this.http.postRequest(this.urlProvider.getPurchaseNewProductsURL(uuid), requestPayload).toPromise().then((res: GenericResponse<string>) => res)
  }

  public getApplicationByToken(requestPayload: GetOnlineApplicationByToken): Promise<GenericResponse<OnlineApplicationRequestPayload>> {
    return this.http.postRequest(this.urlProvider.getGetApplicationByTokenURL(), requestPayload).toPromise().then((res: GenericResponse<OnlineApplicationRequestPayload>) => res);
  }

  public approveApplication(requestPayload: GetOnlineApplicationByToken): Promise<GenericResponse<string>> {
    return this.http.postRequest(this.urlProvider.approveApplicationURL(), requestPayload).toPromise().then((res: GenericResponse<string>) => res);
  }

  public rejectApplication(requestPayload: GetOnlineApplicationByToken): Promise<GenericResponse<string>> {
    return this.http.postRequest(this.urlProvider.rejectApplicationURL(), requestPayload).toPromise().then((res: GenericResponse<string>) => res);
  }

  public sendApplicationLinkToAgent(requestPayload: SendAppLinkToAgentRequest): Promise<GenericResponse<string>> {
    return this.http.postRequest(this.urlProvider.sendApplicationLinkToAgentURL(), requestPayload).toPromise().then((res: GenericResponse<string>) => res);
  }

  public updateGibRegistrationDate(requestPayload: UpdateGibRegistrationDateRequest): Promise<GenericResponse<string>> {
    return this.http.postRequest(this.urlProvider.updateGibRegistrationDateURL(), requestPayload).toPromise().then((res: GenericResponse<string>) => res)
  }

  public sendApplicationLinkToUnits(identifier: string): Promise<GenericResponse<string>> {
    return this.http.getRequest(this.urlProvider.sendApplicationLinkToUnitsURL(identifier)).toPromise().then((res: GenericResponse<string>) => res);
  }

  public getApplicationHistoryByUUID(uuid: string): Promise<GenericResponse<OnlineAppHistoryModel>> {
    return this.http.getRequest(this.urlProvider.getApplicationHistoryByUUIDURL(uuid)).toPromise().then((res: GenericResponse<OnlineAppHistoryModel>) => res);
  }

  public sendMailVerificationForNewForm(email: string,identifier: string): Promise<GenericResponse<string>> {
    var url = this.urlProvider.sendMailVerificationForNewForm(email,identifier);
    return this.http.getRequest(url, true).toPromise().then((res: GenericResponse<string>) => res)
  }
  public sendMailVerificationForPaymentCancel(email: string): Promise<GenericResponse<string>> {
    var url = this.urlProvider.sendMailVerificationForPaymentCancel(email);
    return this.http.getRequest(url, true).toPromise().then((res: GenericResponse<string>) => res)
  }  
  public checkConfirmCodeComparison(confirmCode: string, encryptedConfirmCode: string): Promise<GenericResponse<string>> {
    var url = this.urlProvider.checkConfirmCodeComparison(confirmCode, encryptedConfirmCode);
    return this.http.getRequest(url, true).toPromise().then((res: GenericResponse<string>) => res)
  }
  public getIdentifierExistCustomer(identifier: string): Promise<GenericResponse<boolean>> {
    var url = this.urlProvider.getIdentifierExistCustomer(identifier);
    return this.http.getRequest(url, true).toPromise().then((res: GenericResponse<boolean>) => res)
  }

  public getCancelInformationByIdentifier(identifier: string): Promise<GenericResponse<string>> {
    return this.http
      .getRequest(this.urlProvider.getCancelInformationByIdentifier(identifier))
      .toPromise()
      .then((res: GenericResponse<string>) => res);
  }

  public submitCancelApplication(cancelProduct: CancelProduct): Promise<any> {
    return this.http
      .postRequest(this.urlProvider.submitCancelApplication(), cancelProduct)
      .toPromise()
      .then((res: GenericResponse<string>) => res)
  }

  public updateStatusForNewProducts(identifier: string, status: boolean): Promise<any> {
    return this.http
      .postRequest(this.urlProvider.updateStatusForNewProducts(identifier, status))
      .toPromise()
      .then((res: GenericResponse<string>) => res)
  }

  public getAliasAndBranchByIdentifier(identifier: string, appType: number): Promise<GenericResponse<string>> {
    return this.http
      .getRequest(this.urlProvider.getAliasAndBranchByIdentifier(identifier, appType))
      .toPromise()
      .then((res: GenericResponse<string>) => res)

  }

  public cancelOnlineApplication(cancelOnlineApplication: CancelOnlineApplicationModel): Promise<any> {
    return this.http
      .postRequest(this.urlProvider.cancelOnlineApplication(), cancelOnlineApplication)
      .toPromise()
      .then((res: GenericResponse<string>) => res)
  }

  public getIsHasContinueCancelApplicationByIdentifier(identifier: string): Promise<GenericResponse<string>> {
    return this.http
      .getRequest(this.urlProvider.getIsHasContinueCancelApplicationByIdentifier(identifier))
      .toPromise()
      .then((res: GenericResponse<string>) => res)

  }

  // Paynet ödeme servisi
  public charge(amount :string ): Promise<any> {
    return this.http
    .postRequest(this.urlProvider.charge(),amount)
    .toPromise()
    .then((res: GenericResponse<string>) => res)
  }

  public createOnlineApplication(identifier: string): Promise<any> {
    return this.http
      .postRequest(this.urlProvider.createOnlineApplication(identifier))
      .toPromise()
      .then((res: GenericResponse<string>) => res)
  }

  public loginWithPortalUser(code: string): Promise<GenericResponse<MainMenuResponseModel>> {
    var encodedCode = encodeURIComponent(code);
    return this.http
      .getRequest(this.urlProvider.loginWithPortalUser(encodedCode))
      .toPromise()
      .then((res: GenericResponse<MainMenuResponseModel>) => res)

  }

  //guard
  isLoggedIn(): boolean {
    const vkntckn = localStorage.getItem("vkntckn");
    if (vkntckn) {
      return true;
    } else {
      this.router.navigate(['/form']);
      return false;
    }
  }
  
  //#region PAYMENT ENDPOINT
  public getPaymentPlansByAgent(agentCode:string ): Promise<GenericResponse<PaymentOptionListComponentModel>>{
    return this.http
    .getRequest(this.urlProvider.getPaymentPlansByAgent(agentCode))
    .toPromise()
    .then((res: GenericResponse<PaymentOptionListComponentModel>) => res)
  }

  public submitCustomerPaymentPlan(requestPayload: OnlineApplicationRequestPayload,isAgentEdit:any): Promise<any> {
    return this.http.postRequest(this.urlProvider.getSubmitApplicationURL(isAgentEdit), requestPayload).toPromise().then((res: GenericResponse<string>) => res)
  }
  
  //Payment-Request
  public sendPaymentRequest(requestPayload: PaymentInitialRequest): Promise<GenericResponse<PaymentInitialResponseModel>> {
    return this.http.postRequest(this.urlProvider.tdsInitial(), requestPayload).toPromise().then((res: GenericResponse<PaymentInitialResponseModel>) => res);
  }
  public sendPaymentChargeRequest(requestPayload: PaymentChargeRequestModel): Promise<GenericResponse<PaymentChargeResponseModel>> {
    return this.http.postRequest(this.urlProvider.tdsCharge(), requestPayload).toPromise().then((res: GenericResponse<PaymentChargeResponseModel>) => res);
  }
  public UpdatePaymentSummary(requestPayload: PaymentInformationRequestModel): Promise<GenericResponse<string>> {
    return this.http.postRequest(this.urlProvider.UpdatePaymentSummary(), requestPayload).toPromise().then((res: GenericResponse<string>) => res);
  }
  public sendCancelPaymentRequest(requestPayload: PaymentCancelRequestModel): Promise<GenericResponse<PaymentCancelResponseModel>> {
    return this.http.postRequest(this.urlProvider.reversedRequest(), requestPayload).toPromise().then((res: GenericResponse<PaymentCancelResponseModel>) => res);
  }
  public CancelPaymentSummary(requestPayload: OnlineApplicationRequestModel): Promise<GenericResponse<string>> {
    return this.http.postRequest(this.urlProvider.CancelPayment(), requestPayload).toPromise().then((res: GenericResponse<string>) => res);
  }

  //#endregion

  public getCustomerBalanceByIdentifier(): Promise<GenericResponse<CustomerInventoryRequestPayload>> {
    let vkn = this.aesService.decrypt(localStorage.getItem("vkntckn"));
    return this.http.getRequest(this.urlProvider.getCustomerBalanceByIdentifierURL(vkn)).toPromise().then((res:GenericResponse<CustomerInventoryRequestPayload>) => res);
  }

  public getCustomerPartnersByIdentifier(): Promise<GenericResponse<PartnerModelRequestPayload>> {
    let vkn = this.aesService.decrypt(localStorage.getItem("vkntckn"));
    return this.http.getRequest(this.urlProvider.GetCustomerPartnersByIdentifierURL(vkn)).toPromise().then((res:GenericResponse<PartnerModelRequestPayload>) => res);
  }

  public sendCustomerNewBalance(request: CustomerPackagesRequestModel): Promise<any> {
    return this.http.postRequest(this.urlProvider.SendCustomerNewBalance(), request).toPromise().then((res: GenericResponse<NoDataDto>) => res)
  }
  
  public setCustomerMembership(request: CustomerMembership): Promise<any> {
    return this.http.postRequest(this.urlProvider.SetCustomerMembership(), request).toPromise().then((res: GenericResponse<string>) => res)
  }

  public getCustomerPartners(identifier: string): Promise<GenericResponse<string>> {
    return this.http
      .getRequest(this.urlProvider.getCustomerPartners(identifier))
      .toPromise()
      .then((res: GenericResponse<string>) => res);
  }
}
